import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

type ItemsProp = {
    id: number|string,
    value: string,
};

@Component({})
export default class SelectMixin extends Vue {
    @Prop({ type: Array, default: () => ([]) }) items!: ItemsProp[];
    @Prop({ type: Object, default: null })  current!: ItemsProp|null;
    @Prop({ type: String, default: '' })  error!: string;
    @Prop({ type: String, default: null })  clearAction!: string;
    @Prop({ type: String, default: '' })  title!: string;
    @Prop({ type: Boolean, default: false }) clearAfterClose!: boolean;
    @Prop({ type: Boolean }) disabled?: boolean;
    @Prop({ default: false }) readonly!: boolean;

    visible = false;
    val = this.current;
    search = '';
    stateClass = '';
    classOpen = 'open';
    loadedItems: any[] = [];
    isOpeningBlocked = false;

    mounted (): void {
        document.body.addEventListener('click', this.documentClick);
    }

    beforeDestroy () {
        document.body.removeEventListener('click', this.documentClick);
    }

    @Watch('current')
    onCurrentChange (val: ItemsProp): void {
        this.val = val;
    }

    documentClick(e: Event) {
        const el = this.$refs.dropdownSelect as HTMLDivElement;
        const target = e.target as HTMLDivElement;

        if (this.visible) {
            if (el && el !== target && !el.contains(target)) {
                this.closeState();
            }
        }
    }

    closeState() {
        this.visible = false;
        this.stateClass = '';
        
        if (this.clearAfterClose) {
            this.search = '';
        }
    }

    openSelect() {
        if (this.readonly || this.isOpeningBlocked || this.disabled) {
            return;
        }

        this.stateClass = this.classOpen;
        this.visible = true
    }

    selectValue(id: number|string, value: string) {
        const newValue = {
            id: id,
            value: value,
        };
        this.val = newValue;
        this.search = '';

        this.$emit('click', newValue);

        this.closeState();
        
        // input somehow catches click after closing and that triggers reopening
        this.isOpeningBlocked = true;
        setTimeout(() => {
            this.isOpeningBlocked = false;
        }, 10)
    }

    resetValue() {
        this.$emit('reset');
    }
}
